import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import { BurgerMenuButtonModule } from '@app/components/burgerMenuButton/burgerMenuButton.module';
import { MenuButtonProfileModule } from '@app/components/menuButtonProfile/menuButtonProfile.module';
import { ReleaseStageDisplayComponent } from '@app/components/releaseStageDisplay/releaseStageDisplay.component';

@NgModule({
  imports: [CommonModule, BurgerMenuButtonModule, MenuButtonProfileModule, ReleaseStageDisplayComponent],
  declarations: [HeaderComponent],
  exports: [HeaderComponent],
})
export class HeaderModule {}
